// Background Mux video uploads (movies, shorts, episodes) tracked globally so
// progress/status stay visible no matter which page the admin navigates to.

export const ADD_UPLOAD = "ADD_UPLOAD";
export const UPDATE_UPLOAD_PROGRESS = "UPDATE_UPLOAD_PROGRESS";
export const SET_UPLOAD_PROCESSING = "SET_UPLOAD_PROCESSING";
export const SET_UPLOAD_READY = "SET_UPLOAD_READY";
export const SET_UPLOAD_ERROR = "SET_UPLOAD_ERROR";
export const REMOVE_UPLOAD = "REMOVE_UPLOAD";
